import Normal from './normal';

export default {
  Normal
}
